import { ButtonBase, Stack } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { CbhIcon, DotSeparatedList, Text } from "@src/appV2/redesign/system/ui-components";
import pluralize from "pluralize";
import { useHistory } from "react-router-dom";

import { useWorkplaceModalsDataContext } from "../../ShiftDiscovery/useWorkplaceModalsDataContext";
import { PLACEMENT_WORKPLACE_JOBS_PATH } from "../paths";
import { type PlacementWorkplaceListItemData } from "./usePlacementWorkplaceSearch";

const PLACEMENT_WORKPLACE_SEARCH_SOURCE = "placement_workplace_search";

interface PlacementWorkplaceListItemProps extends PlacementWorkplaceListItemData {
  searchTerm: string;
}

export function PlacementWorkplaceListItem(props: PlacementWorkplaceListItemProps) {
  const { workplaceId, name, formattedDistance, placementsCount, searchTerm } = props;

  const history = useHistory();
  const { generateModalPath } = useWorkplaceModalsDataContext();

  return (
    <ButtonBase
      sx={{ textAlign: "left" }}
      onClick={() => {
        logEvent(APP_V2_USER_EVENTS.PLACEMENT_WORKPLACE_SELECTED, {
          workplaceId,
          source: PLACEMENT_WORKPLACE_SEARCH_SOURCE,
          searchTerm: searchTerm.trim(),
        });

        history.push(
          generateModalPath(PLACEMENT_WORKPLACE_JOBS_PATH, {
            workplaceId,
          })
        );
      }}
    >
      <Stack direction="row" spacing={2} width="100%">
        <CbhIcon type="map-pin" size="medium" />

        <Stack alignItems="flex-start" width="100%" gap={1}>
          <Text
            variant="body1"
            sx={{
              fontWeight: "medium",
              color: (theme) => theme.palette.text.primary,
              lineHeight: 1.2,
            }}
          >
            {name}
          </Text>

          <Text inline variant="body2" color="text.secondary">
            <DotSeparatedList inline={false}>
              <Text
                inline
                semibold
                variant="caption"
                color={(theme) => theme.palette.text.secondary}
              >
                {placementsCount} open {pluralize("job", placementsCount)}
              </Text>

              <Text inline variant="caption" color={(theme) => theme.palette.text.secondary}>
                {formattedDistance ? `${formattedDistance} away` : undefined}
              </Text>
            </DotSeparatedList>
          </Text>
        </Stack>
      </Stack>
    </ButtonBase>
  );
}
